<template>
  <div class="salesmanmymemberPage">   
      <XR-head titleText="我的会员" :rightShow="false"></XR-head>
      <div class="total balance" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
          <p class="title">总人数(人)</p>
          <p class="money">{{countInfo.gltotal}}</p>
      </div>
   
      <mu-list>
        <router-link to="/salesman/mymemberlist" class="proList">
          <mu-list-item :title="saleMenCategory?(saleMenCategory[0]?saleMenCategory[0]:'普通会员'):'普通会员'">
            <mu-icon slot="left" value=":fa fa-myhuiyuan"/>
            <p>{{countInfo.glpttotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <router-link to="/salesman/mymemberviplist" class="proList">
          <mu-list-item :title="saleMenCategory?saleMenCategory[1]:'消费商'">
            <mu-icon slot="left" value=":fa fa-mydianzhu  "/>
            <p>{{countInfo.glzctotal}}</p>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>        
      </mu-list>
      <!-- <XR-toast ref="XRtoast"></XR-toast> -->
  </div>
</template>
<script>
export default {
  data () {
    return {
     searchInfo:{
       pageIndex:1,
       pageSize:1000,
       zcpv:0,
       shbs:1,
       startdate:'',
       enddate:'',
       e:1
     },
     countInfo:{
       glzctotal:0,
       glpttotal:0,
       gltotal:0
     },
     memberList:{},
     siteConfig:{ MobileBgImage : '' },
	 saleMenCategory:window.localStorage.saleMenCategory.split(",")
    }
  },
  mounted(){
    this.getSiteInfo()
    this.getCount()
  },
  methods: {
    getCount(){           
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetMyShopMemberCount", this.searchInfo)
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          
          ths.countInfo = res.Data

          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    getSiteInfo: function () {    
        const ths = this;
        this.$post('/Shop/SiteConfigServer/GetSiteConfig')
            .then(function (res) {
            if(res.IsSuccess){
                ths.siteConfig = res.Data
            }         
        })
        .catch(function (err) {
            console.log(err)
        })    
    },      
  }
}
</script>
<style>
     body .salesmanmymemberPage{
        background: #fff;
      }
     body .salesmanmymemberPage .total {
          padding: 20px;
          overflow: hidden;
          background: url("/static/us-top-bg.png");
          background-size: 100% 100%;
      }
      .salesmanmymemberPage .title {
          line-height: 24px;
          font-size: 14px;
          color: #fff;
      }
      .salesmanmymemberPage .show-right .mu-item-content{
          display: flex;
      }
      .salesmanmymemberPage .show-right .mu-item-title-row{
        width: 100%;
      }
      .salesmanmymemberPage .text{
        color: #666666;
      }
      .salesmanmymemberPage .money {
          font-size: 46px;
          color: red;
          line-height: 42px;
          padding: 10px 0;
          letter-spacing: -1px;
          color: #fff;
      }
      .salesmanmymemberPage .mu-appbar .mu-appbar-title{
        font-size: 16px;
      }
      .salesmanmymemberPage h5
        {
            font-size:16px;
            text-align:center;  
            font-weight:400;  
            padding:17px 0;
        }
      .salesmanmymemberPage h5 em
        {
            color:#333;
        }
      .salesmanmymemberPage .mu-item.show-left{
        padding-left: 50px;
      }
      .salesmanmymemberPage .mu-list{
        margin-top: 10px;
      }
      .salesmanmymemberPage .proList .mu-ripple-wrapper{
        border-bottom: 1px solid #f5f5f5;
      }
      .salesmanmymemberPage .mu-avatar-inner,.salesmandailizhongxingPage  .mu-tabs{
        font-size: 12px;
      }
      .salesmanmymemberPage .proList .mu-icon{
        margin-bottom: 5px; 
      }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/mymember.vue